import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Autocomplete,
  TextField,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import { RootState } from '../../../store/store';
import {
  setResultVisualizationExpFilter,
  setResultVisualizationFilter,
} from '../../../store/filterSlice';
import {
  setPredefinedLagForSt,
  setPredefinedLagForMt,
} from '../../../store/lagDropdownSlice';

const PredefinedLagDropdown: React.FC = () => {
  const dispatch = useDispatch();
  const [length, setLength] = useState<boolean>(true);
  const expData = useSelector(
    (state: RootState) => state.resultVisualizationExperimentationData
  );
  const filters = useSelector((state: RootState) => state.rcaFilter);
  const userData = useSelector((state: RootState) => state.user);
  const [selectedLag, setSelectedLag] = useState<string | null | number>(null);
  const defaultLag =
  filters?.term?.toString() === 'ST'
    ? userData?.userSectorData?.defaultForecastLagNumber?.st
    : userData?.userSectorData?.defaultForecastLagNumber?.mt;

  useEffect(() => {
   
    setSelectedLag(defaultLag as string);
    dispatch(
      setResultVisualizationExpFilter({
        key: 'lagNumber',
        value: [defaultLag as string],
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.term, dispatch]);

  useEffect(() => {   
    
    setSelectedLag(defaultLag as string);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLag]);

  useEffect(() => {
    setLength(expData?.forecastLagNumbers?.length > 0 ? false : true);

    if (filters?.term?.toString() === 'ST') {
      if(expData?.forecastLagNumbers?.includes(Number(selectedLag))) {
        dispatch(setPredefinedLagForSt(selectedLag as number));
      } else {
        dispatch(setPredefinedLagForSt(null));
      }
    }

    if (filters?.term?.toString() === 'MT') {
      if(expData?.forecastLagNumbers?.includes(Number(selectedLag))) {
        dispatch(setPredefinedLagForMt(selectedLag as number));
      } else {
        dispatch(setPredefinedLagForMt(null));
      }
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expData, selectedLag]);

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        paper: '#272727',
      },
      text: {
        primary: '#ffffff',
      },
    },
  });

  const handleLagChange = (
    event: React.SyntheticEvent,
    value: string | null
  ) => {
    setSelectedLag(value);
    if (value !== null) {
      if (filters?.term?.toString() === 'ST') {
        dispatch(setPredefinedLagForSt(Number(value)));
      }
      if (filters?.term?.toString() === 'MT') {
        dispatch(setPredefinedLagForMt(Number(value)));
      }
    }

    dispatch(
      setResultVisualizationFilter({
        key: 'lagNumber',
        value: value !== null ? [value] : [],
      })
    );
  };
  return (
    <ThemeProvider theme={darkTheme}>
      <div className='lag-dropdown-container'>
        <Autocomplete
          className='p-2'
          options={
            expData?.forecastLagNumbers
              ?.slice()
              .map((num) => num.toString())
              .sort((a, b) => parseInt(a, 10) - parseInt(b, 10)) || []
          }
          getOptionLabel={(option) => option.toString()}
          value={
            length
              ? ''
              : expData?.forecastLagNumbers?.includes(Number(selectedLag))
              ? selectedLag as string
              : ''
          }
          onChange={handleLagChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Lag'
              variant='outlined'
              sx={{
                '& .MuiAutocomplete-input': {
                  minWidth: '34px !important'
                },
                '& .MuiOutlinedInput-root': {
                  color: 'white',
                  borderColor: '#616161',
                },
                '& .MuiInputLabel-root': {
                  color: '#909090',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#616161',
                },
              }}
            />
          )}
          sx={{
            '& .MuiAutocomplete-popupIndicator': {
              color: 'white',
            },
            '& .MuiAutocomplete-clearIndicator': {
              color: 'white',
            },
          }}
        />
      </div>
    </ThemeProvider>
  );
};

export default PredefinedLagDropdown;
